import React from 'react';
import PropTypes from 'prop-types';
import { oarsAnalysis } from './reviewData';

// items를 넘기지 않으면 예시 데이터를 보여준다.
export default function BehaviorAnalysis({ items = oarsAnalysis, tag = '학습용 예시' }) {
    return <article className="review-card review-behavior" aria-labelledby="behavior-title">
        <span className="ai-kicker">COUNSELOR BEHAVIOR</span>
        <h2 id="behavior-title">상담자 행동 빈도</h2>
        <p className="ai-small">OARS 기법의 분포를 통해 어떤 반응을 주로 사용했는지 살펴보세요.</p>

        <section aria-labelledby="oars-title">
            <div className="review-row"><h3 id="oars-title">OARS 비율 분석</h3><span className="review-tag">{tag}</span></div>
            <div className="oars-distribution" aria-hidden="true">{items.map(item => <span key={item.code} className={`oars-color-${item.code}`} style={{ width: `${item.percent}%` }}>{item.code}</span>)}</div>
            <ul className="oars-list">{items.map(item => <li key={item.code}>
                <div className="oars-heading"><span className={`oars-letter oars-color-${item.code}`}>{item.code}</span><strong className="oars-label">{item.label}</strong><strong className="oars-percent">{item.percent}%</strong></div>
                <div className="oars-result"><span className={`oars-status ${item.tone}`}>{item.status}</span>{typeof item.count === 'number' && <span className="oars-count"> · {item.count}회</span>}</div>
                <p className="ai-small">{item.description}</p>
            </li>)}</ul>
            <p className="ai-small oars-method">OARS에 해당하는 발화를 주기법 하나로 분류한 비율입니다(합계 100%). 요약(S)은 반영(R)에 중복 집계하지 않습니다. 상태는 제시된 학습용 평가이며 MITI 평정 기준이 아닙니다.</p>
        </section>


    </article>;
}
BehaviorAnalysis.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        code: PropTypes.string.isRequired, label: PropTypes.string, percent: PropTypes.number,
        count: PropTypes.number, status: PropTypes.string, tone: PropTypes.string, description: PropTypes.string,
    })),
    tag: PropTypes.string,
};
